// Tiny sessionStorage wrapper so a persona/language choice survives navigation
// from /start → /journey without a state manager.
const KEY = 'alfred_mh_session';

export function readSession() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function writeSession(patch) {
  const next = { ...readSession(), ...patch };
  sessionStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function clearSession() {
  sessionStorage.removeItem(KEY);
}
